<template>
  <svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.9287 7.73633L50.9287 30.2363L15.9287 52.7363V7.73633Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
